<div class="editor-container">
  <div class="editor-wrapper">
    <readonly-frame-editor [id]="READONLY_FRAME_EDITOR_ID" [html]="html" [bodyClass]="'pageMode-popup'"></readonly-frame-editor>
  </div>
</div>
